import { DATE_VALUES, getRangeFromDateFilter } from 'utils/dateUtils'

import {
  DATE_FILTER_CHANGE as HOME_DATE_FILTER_CHANGE,
  SCANBACK_CHANGE,
} from 'containers/Dashboard/Home/constants'

import { COMPANY_FILTER_CHANGE } from '../../../PartnerOptions/constants'

import {
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  FETCH_ALL_FILTERS_ASYNC,
  MAILBOX_ANOMALY_REQUEST_ASYNC,
  MITIGATION_REQUEST_ASYNC,
  MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC,
  RESET_FILTERS,
  TOP_PROFILES_REQUEST_ASYNC,
} from './constants'

const initialState = {
  loader: false,
  dateFilter: DATE_VALUES.MONTH,
  data: {
    analystResolution: {},
  },
  mostTargetedEmployees: {
    data: {},
    dataSecondPart: {},
    loader: true,
    error: null,
  },
  error: null,
  mitigation: {
    data: {},
    loader: true,
    error: null,
  },
  mailboxAnomaly: {
    data: {},
    loader: true,
    error: null,
  },
  topProfiles: {
    data: {},
    loader: true,
    error: null,
  },

  allFilters: {},
  allFiltersLoader: false,
}

export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.value,
          feDateRange: getRangeFromDateFilter(action.payload.value),
          loader: true,
          mostTargetedEmployees: {
            ...state.mostTargetedEmployees,
            loader: true,
            error: null,
          },
        }
      case SCANBACK_CHANGE:
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          loader: true,
          error: null,
          mostTargetedEmployees: {
            ...state.mostTargetedEmployees,
            loader: true,
            error: null,
          },
        }
      case DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
          mitigation: {
            ...state.mitigation,
            loader: true,
            error: null,
          },
          mailboxAnomaly: {
            ...state.mailboxAnomaly,
            loader: true,
            error: null,
          },
          topProfiles: {
            ...state.topProfiles,
            loader: true,
            error: null,
          },
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case MITIGATION_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          mitigation: {
            ...state.mitigation,
            loader: false,
            data: action.payload.data,
          },
        }
      case MITIGATION_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          mitigation: {
            ...state.mitigation,
            loader: false,
            error: action.error,
          },
        }
      case MITIGATION_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          mitigation: {
            ...state.mitigation,
            loader: false,
          },
        }

      case TOP_PROFILES_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          topProfiles: {
            ...state.topProfiles,
            loader: false,
            data: action.payload.data,
          },
        }
      case TOP_PROFILES_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          topProfiles: {
            ...state.topProfiles,
            loader: false,
            error: action.error,
          },
        }
      case TOP_PROFILES_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          topProfiles: {
            ...state.topProfiles,
            loader: false,
          },
        }

      case MAILBOX_ANOMALY_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          mailboxAnomaly: {
            ...state.mailboxAnomaly,
            loader: false,
            data: action.payload.data,
          },
        }
      case MAILBOX_ANOMALY_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          mailboxAnomaly: {
            ...state.mailboxAnomaly,
            loader: false,
            error: action.error,
          },
        }
      case MAILBOX_ANOMALY_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          mailboxAnomaly: {
            ...state.mailboxAnomaly,
            loader: false,
          },
        }
      case FETCH_ALL_FILTERS_ASYNC.INITIATE:
        return { ...state, allFiltersLoader: true }
      case FETCH_ALL_FILTERS_ASYNC.SUCCESS:
        return {
          ...state,
          allFiltersLoader: false,
          allFilters: action.payload.data,
        }
      case FETCH_ALL_FILTERS_ASYNC.ERROR:
      case FETCH_ALL_FILTERS_ASYNC.CANCEL:
        return { ...state, allFiltersLoader: false }
      case HOME_DATE_FILTER_CHANGE:
      case MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          mostTargetedEmployees: {
            ...state.mostTargetedEmployees,
            loader: true,
            error: null,
          },
        }
      case MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          mostTargetedEmployees: {
            data: action.payload.data?.slice(0, 5),
            dataSecondPart: action.payload.data?.slice(5),
            loader: false,
            error: null,
          },
        }
      case MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          mostTargetedEmployees: {
            ...state.mostTargetedEmployees,
            loader: false,
            error: action.error,
          },
        }
      case MOST_ATTACKED_EMPLOYEES_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          mostTargetedEmployees: {
            ...state.mostTargetedEmployees,
            loader: false,
          },
        }
      case RESET_FILTERS:
        return {
          ...state,
          dateFilter: DATE_VALUES.MONTH,
          feDateRange: getRangeFromDateFilter(DATE_VALUES.MONTH),
        }
      default:
        return state
    }
  }
}
